import { converterDataHoraBr } from "_utils/Data";
import { FaDownload, FaTrash } from "react-icons/fa";
import {
  IColunaTabelaPadrao,
  TabelaPadrao,
} from "../../../SolicitacaoPlaca/components/TabelaPadrao";
import { DirecaoOrdenacao } from "../../../SolicitacaoPlaca/interfaces/IOrdenacao";
import { ORDENACAO_LOTES_TERCEIROS_PADRAO } from "../../constants/filtrosLotesTerceiros";
import { ILoteTerceiros } from "../../interfaces/ILoteTerceiros";

const SEM_VALOR = "—";

interface IProps {
  lotes: ILoteTerceiros[];
  totalRegistros: number;
  carregando: boolean;
  limite: number;
  reiniciarPaginacao: boolean;
  onMudarPagina: (pagina: number) => void;
  onMudarLimite: (limite: number) => void;
  onOrdenar: (campo: string, direcao: DirecaoOrdenacao) => void;
  onExportar: () => void;
  exportando: boolean;
  baixando: number | null;
  onBaixar: (id: number) => void;
  onRemover: (lote: ILoteTerceiros) => void;
}

export function ListarLotes({
  lotes,
  totalRegistros,
  carregando,
  limite,
  reiniciarPaginacao,
  onMudarPagina,
  onMudarLimite,
  onOrdenar,
  onExportar,
  exportando,
  baixando,
  onBaixar,
  onRemover,
}: IProps) {
  const colunas: IColunaTabelaPadrao<ILoteTerceiros>[] = [
    {
      chave: "lote",
      titulo: "Lote",
      selector: ({ id }) => id,
      sortable: true,
      sortField: "lote",
      width: "100px",
    },
    {
      chave: "fornecedor",
      titulo: "Fornecedor",
      selector: ({ fornecedor }) => fornecedor || SEM_VALOR,
      sortable: true,
      sortField: "fornecedor",
      minWidth: "180px",
    },
    {
      chave: "emails",
      titulo: "E-mail",
      selector: ({ emails }) => (emails.length ? emails.join(", ") : SEM_VALOR),
      sortable: true,
      sortField: "emails",
      minWidth: "300px",
    },
    {
      chave: "criadoEm",
      titulo: "Enviado em",
      selector: ({ criadoEm }) => converterDataHoraBr(criadoEm) ?? SEM_VALOR,
      sortable: true,
      sortField: "criadoEm",
      width: "190px",
    },
    {
      chave: "usuario",
      titulo: "Usuário",
      selector: ({ usuario }) => usuario ?? SEM_VALOR,
      sortable: true,
      sortField: "usuario",
      minWidth: "180px",
    },
    {
      chave: "placas",
      titulo: "Placas",
      selector: ({ qtdPlacas }) => qtdPlacas,
      sortable: true,
      sortField: "placas",
      width: "100px",
    },
    {
      chave: "acoes",
      titulo: "Ações",
      selector: ({ id }) => id,
      cell: (lote) => (
        <div style={{ display: "flex", gap: "1rem" }}>
          <FaDownload
            title="Baixar Excel"
            style={{
              cursor: baixando === null ? "pointer" : "wait",
              opacity: baixando === lote.id ? 0.4 : 1,
            }}
            onClick={() => baixando === null && onBaixar(lote.id)}
          />
          <FaTrash
            title="Remover lote"
            style={{ cursor: "pointer" }}
            onClick={() => onRemover(lote)}
          />
        </div>
      ),
      width: "100px",
    },
  ];

  return (
    <TabelaPadrao
      titulo="Lotes criados"
      chaveConfigColunas="placaTerceiros:lotes:colunas"
      limitarALargura
      colunas={colunas}
      dados={lotes}
      carregando={carregando}
      totalRegistros={totalRegistros}
      limite={limite}
      colunaOrdenadaInicial={ORDENACAO_LOTES_TERCEIROS_PADRAO.campo}
      direcaoOrdenacaoInicial={ORDENACAO_LOTES_TERCEIROS_PADRAO.direcao}
      reiniciarPaginacao={reiniciarPaginacao}
      onMudarPagina={onMudarPagina}
      onMudarLimite={onMudarLimite}
      onOrdenar={onOrdenar}
      onExportar={onExportar}
      exportando={exportando}
    />
  );
}
